import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import '../styles/ContactProfile.css';

function ContactProfile({ contact }) {
  return (
    <div className="contact-profile">
      <div className="profile-header">
        <div className="profile-avatar">
          {contact.name.charAt(0).toUpperCase()}
        </div>
        <div className="profile-title">
          <h3>{contact.name}</h3>
          <p className="title">{contact.title}</p>
          <p className="company">{contact.company}</p>
        </div>
      </div>

      <div className="profile-section">
        <h4>Details</h4>
        <div className="detail-grid">
          {contact.city && (
            <div className="detail-item">
              <span className="label">Location</span>
              <span className="value">{contact.city}, {contact.country}</span>
            </div>
          )}
          {contact.languages && (
            <div className="detail-item">
              <span className="label">Languages</span>
              <span className="value">{contact.languages}</span>
            </div>
          )}
          {contact.profile_cat && (
            <div className="detail-item">
              <span className="label">Category</span>
              <span className="value">{contact.profile_cat}</span>
            </div>
          )}
        </div>
      </div>

      {contact.channels && (
        <div className="profile-section">
          <h4>Contact Channels</h4>
          <div className="channels-list">
            {contact.channels.email && (
              <div className="channel">
                <span className="channel-icon">✉️</span>
                <span>{contact.channels.email.join(', ')}</span>
              </div>
            )}
            {contact.channels.whatsapp && (
              <div className="channel">
                <span className="channel-icon">💬</span>
                <span>{contact.channels.whatsapp.join(', ')}</span>
              </div>
            )}
            {contact.channels.linkedin && (
              <div className="channel">
                <span className="channel-icon">🔗</span>
                <span>{contact.channels.linkedin.join(', ')}</span>
              </div>
            )}
            {contact.channels.telegram && (
              <div className="channel">
                <span className="channel-icon">📱</span>
                <span>{contact.channels.telegram.join(', ')}</span>
              </div>
            )}
          </div>
        </div>
      )}

      {contact.last_touch && (
        <div className="profile-section">
          <h4>Interaction History</h4>
          <p>Last touch: {formatDistanceToNow(new Date(contact.last_touch), { addSuffix: true })}</p>
        </div>
      )}
    </div>
  );
}

export default ContactProfile;
